module.exports = "https://r.nearpod.com/assets/media/image/nearpod-icon-9d0b382d4e5c75e88e80e0e57989aab7.svg";